import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

// Debug: Log the Appeals API base URL
console.log('[AppealsAPI] Base URL:', API_BASE_URLS.appeals);

/**
 * Appeals API - Base definition
 *
 * This is the base API slice for the Appeals service.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see appealEndpoints.ts - Appeal letter CRUD and generation
 * @see policyEndpoints.ts - Policy document management and search
 * @see agentEndpoints.ts - AI Agent chat and info
 */
export const appealsApi = createApi({
  reducerPath: 'appealsApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.appeals),
  tagTypes: ['Appeal', 'AppealList', 'Policy', 'PolicyList', 'PolicySearch'],
  endpoints: () => ({}),
});
